import React from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle, TrendingUp } from "lucide-react";

export function PropertiesLimitModal({ isOpen, onClose, config }) {
  const navigate = useNavigate();

  if (!config) return null;

  const handleUpgrade = () => {
    navigate("/pricing");
    onClose();
  };

  const handleViewProperties = () => {
    navigate("/account?tab=properties");
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-2">
            <AlertTriangle className="w-5 h-5 text-yellow-600" />
            <DialogTitle>{config.title}</DialogTitle>
          </div>
          <DialogDescription>
            Ya tienes {config.current} de {config.limit} propiedades activas en tu plan {config.plan}.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="bg-blue-50 dark:bg-blue-950 border border-blue-200 dark:border-blue-800 rounded-lg p-3">
            <p className="text-sm font-medium text-blue-900 dark:text-blue-100">
              Consejo: puedes archivar propiedades antiguas para liberar espacio o actualizar tu plan para operar con inventario ilimitado.
            </p>
          </div>

          <div className="space-y-2">
            <h4 className="text-sm font-semibold">Opciones disponibles</h4>
            <ul className="text-sm text-muted-foreground space-y-1">
              <li className="flex items-start gap-2">
                <span className="text-primary">→</span>
                <span>Actualiza a <strong>Asesor Inmobiliario</strong> o <strong>Desarrolladora</strong> para operar con propiedades ilimitadas</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary">→</span>
                <span>Archiva propiedades publicadas anteriormente para liberar espacio</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex gap-2 justify-end">
          <Button variant="outline" onClick={handleViewProperties}>
            Ver mis propiedades
          </Button>
          <Button onClick={handleUpgrade} className="gap-2">
            <Upgrade className="w-4 h-4" />
            Actualizar plan
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
